import SearchStore from 'stores/anyroad/search';
import _ from 'underscore';
import $ from 'jquery';
import RSVP from 'rsvp';

let searchRequest;

const DEFAULT_FILTERS = {
  page: 1,
  sort: 'relevance',
};

const SearchService = {
  fetchTours() {
    if (searchRequest && searchRequest.abort) {
      searchRequest.abort();
    }

    const searchStore = SearchStore.state.toJS();
    const searchUrl = SearchService.buildSearchUrl(searchStore);

    return new RSVP.Promise((resolve, reject) => {
      searchRequest = $.get(searchUrl, resolve).fail(reject);
    }).then((json) => {
      if (typeof history.pushState === 'function') {
        history.pushState(
          '',
          '',
          `?${$.param(SearchService.buildFilters(searchStore, true))}`
        );
      }
      return json;
    });
  },

  buildSearchUrl(store) {
    return `/t/${store.location.replace(/\./g, '')}.json?${$.param(
      SearchService.buildFilters(store, false)
    )}`;
  },

  buildFilters(store, forPushState) {
    const query_filters = {
      from: store.filters.availability.from,
      to: store.filters.availability.to,
      people: store.filters.availability.people,
      interests: (store.filters.categories || []).join(','),
      sort: store.sort,
    };

    // Never change the page in the URL when
    // appending tours to the tour list on mobile
    if (forPushState && store.appending) {
      query_filters.page = 1;
    } else {
      query_filters.page = store.meta.current_page;
    }

    return _.omit(query_filters, (value, key, _object) => {
      return (
        !_.isPresent(value) || DEFAULT_FILTERS[key] === value || value === ''
      );
    });
  },

  postInquiry(params) {
    return new RSVP.Promise((resolve, reject) => {
      $.post('/search/inquiries.json', params, resolve).fail(reject);
    });
  },
};

export default SearchService;
